var _title, _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgViewOff = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "12px",
    viewBox: "0 0 14 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "\uD83D\uDD39 Icon Color")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.6410473%",
    y1: "50.3589527%",
    x2: "0.358952703%",
    y2: "50.3589527%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0039CB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.875,2.21875 C9.24375,2.21875 11.35625,3.55 12.3875,5.65625 C12.01875,6.41875 11.5,7.075 10.88125,7.60625 L11.7625,8.4875 C12.63125,7.71875 13.31875,6.75625 13.75,5.65625 C12.66875,2.9125 10,0.96875 6.875,0.96875 C6.08125,0.96875 5.31875,1.09375 4.6,1.325 L5.63125,2.35625 C6.0375,2.275 6.45,2.21875 6.875,2.21875 Z M6.20625,2.93125 L7.5,4.225 C7.85625,4.38125 8.14375,4.66875 8.3,5.025 L9.59375,6.31875 C9.64375,6.10625 9.68127311,5.88125 9.68127311,5.65 C9.6875,4.1 8.425,2.84375 6.875,2.84375 C6.64375,2.84375 6.425,2.875 6.20625,2.93125 Z M0.63125,0.8875 L2.30625,2.5625 C1.2875,3.3625 0.48125,4.425 0,5.65625 C1.08125,8.4 3.75,10.34375 6.875,10.34375 C7.825,10.34375 8.7375,10.1625 9.575,9.83125 L11.7125,11.96875 L12.59375,11.0875 L1.5125,0 L0.63125,0.8875 Z M5.31875,5.575 L6.95,7.20625 C6.925,7.2125 6.9,7.21875 6.875,7.21875 C6.0125,7.21875 5.3125,6.51875 5.3125,5.65625 C5.3125,5.625 5.31875,5.60625 5.31875,5.575 L5.31875,5.575 Z M3.19375,3.45 L4.2875,4.54375 C4.14375,4.8875 4.0625,5.2625 4.0625,5.65625 C4.0625,7.20625 5.325,8.46875 6.875,8.46875 C7.26875,8.46875 7.64375,8.3875 7.98125,8.24375 L8.59375,8.85625 C8.04375,9.00625 7.46875,9.09375 6.875,9.09375 C4.50625,9.09375 2.39375,7.7625 1.3625,5.65625 C1.8,4.7625 2.4375,4.025 3.19375,3.45 Z",
    id: "\\uD83D\\uDD39-Icon-Color",
    fill: "url(#linearGradient-1)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgViewOff, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view_off.9f2e49b9.svg";
export { ForwardRef as ReactComponent };